const STORAGE_KEY = 'efficacitas_keyboard_shortcuts';

export const DEFAULT_SHORTCUTS = {
  newTask: { key: 'n', modifiers: ['ctrl', 'shift'], labelKey: 'shortcuts.newTask' },
  newProject: { key: 'p', modifiers: ['ctrl', 'shift'], labelKey: 'shortcuts.newProject' },
  focusSearch: { key: 'f', modifiers: ['ctrl', 'shift'], labelKey: 'shortcuts.focusSearch' },
  goDashboard: { key: '1', modifiers: ['alt'], labelKey: 'shortcuts.goDashboard' },
  goTasks: { key: '2', modifiers: ['alt'], labelKey: 'shortcuts.goTasks' },
  goProjects: { key: '3', modifiers: ['alt'], labelKey: 'shortcuts.goProjects' },
  goGantt: { key: '4', modifiers: ['alt'], labelKey: 'shortcuts.goGantt' },
  goCalendar: { key: '5', modifiers: ['alt'], labelKey: 'shortcuts.goCalendar' },
  goTimeboxing: { key: '6', modifiers: ['alt'], labelKey: 'shortcuts.goTimeboxing' },
  goArchives: { key: '7', modifiers: ['alt'], labelKey: 'shortcuts.goArchives' },
  goSettings: { key: '8', modifiers: ['alt'], labelKey: 'shortcuts.goSettings' },
};

export function getStoredShortcuts() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      const merged = { ...DEFAULT_SHORTCUTS };
      for (const key of Object.keys(parsed)) {
        merged[key] = { ...DEFAULT_SHORTCUTS[key], ...parsed[key] };
      }
      return merged;
    }
  } catch {
    // ignore parse errors
  }
  return { ...DEFAULT_SHORTCUTS };
}

export function setStoredShortcuts(shortcuts) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(shortcuts));
}

export function resetStoredShortcuts() {
  localStorage.removeItem(STORAGE_KEY);
  return { ...DEFAULT_SHORTCUTS };
}

export function getShortcutsEnabled() {
  const stored = localStorage.getItem('efficacitas_keyboard_shortcuts_enabled');
  return stored !== 'false';
}

export function setShortcutsEnabled(enabled) {
  localStorage.setItem('efficacitas_keyboard_shortcuts_enabled', String(enabled));
}

/**
 * Convertit une config de raccourci en string de combinaison utilisable par useKeyboardShortcuts.
 * Ex: { key: 'n', modifiers: ['ctrl', 'shift'] } => 'ctrl+shift+n'
 */
export function shortcutToCombo(shortcut) {
  const parts = [...(shortcut.modifiers || [])];
  parts.push(shortcut.key.toLowerCase());
  return parts.join('+');
}

/**
 * Retourne un label lisible pour un raccourci.
 * Ex: { key: 'n', modifiers: ['ctrl', 'shift'] } => 'Ctrl+Shift+N'
 */
export function formatShortcutLabel(shortcut) {
  const parts = [...(shortcut.modifiers || [])].map(m => {
    if (m === 'ctrl') return 'Ctrl';
    if (m === 'cmd') return 'Cmd';
    if (m === 'alt') return 'Alt';
    if (m === 'shift') return 'Shift';
    return m;
  });
  parts.push(shortcut.key.toUpperCase());
  return parts.join('+');
}
